import React from 'react'
import classes from './PageCard.module.scss'
import { Link } from 'react-router-dom'
import Icon from '../../Icon/Icon'

interface Props {
  title: string
  icon: string
  contentText: string
  routeLink: string
}

const PageCard = (props: Props): JSX.Element => {
  return (
    <Link
      to={props.routeLink}
      style={{ textDecoration: 'inherit', color: 'inherit' }}
    >
      <div className={classes.root}>
        <div className={classes.top}>
          <span className={classes.title}>{props.title}</span>
          <span className={classes.iconContainer}>
            <Icon iconName={props.icon} color={'#0094bf'} size={24} />
          </span>
        </div>
        <div className={classes.text}>{props.contentText}</div>
      </div>
    </Link>
  )
}

export default PageCard
